import "./Tela04.styles.css";
import { useState } from "react";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { FaPlay } from "react-icons/fa";
import bgTl5 from "../../img/imgsTela4/bgTl5.png";

import videoAline from "../../video/Aline.mp4";

import pessoa1 from "../../img/imgsTela4/pessoa1.jpeg";
import pessoa2 from "../../img/imgsTela4/pessoa2.png";
import pessoa3 from "../../img/imgsTela4/pessoa3.png";
import pessoa4 from "../../img/imgsTela4/pessoa4.png";
import pessoa5 from "../../img/imgsTela4/pessoa5.jpg";
import pessoa6 from "../../img/imgsTela4/pessoa6.png";
import pessoa7 from "../../img/imgsTela4/pessoa7.jpeg";
import pessoa8 from "../../img/imgsTela4/pessoa8.jpeg";
import pessoa9 from "../../img/imgsTela4/pessoa9.jpeg";
import pessoa10 from "../../img/imgsTela4/pessoa10.jpg";
import pessoa11 from "../../img/imgsTela4/pessoa11.jpg";

import video1 from "../../img/imgsTela3/video1.png";

export default function Tela04() {
  
  const pessoas = [
    {
      id: 1,
      nome: "Aline Pimentel da Silva",
      unidade: "SENAI Lauro de Freitas",
      foto: pessoa1,
      thumb: video1,
      video: videoAline,
      descricao:
      "Com auxílio de uma IA, a professora Aline gerou imagens com várias não conformidades, também conduziu os alunos em uma visita técnica imersiva por meio da realidade virtual para que os alunos pudessem identificar não conformidades e propor soluções a partir da metodologia japonesa de organização e gestão dos 5 Sensos.",
    },
    {
      id: 2,
      nome: "Amanda Lienthier",
      unidade: "SENAI Cimatec",
      foto: pessoa2,
      thumb: video1,
      videoUrl: "https://www.youtube.com/embed/cVjBeLNSSgk?si=QmVAzMmoIVPvkm48",
      descricao:
      "A professora Amanda, utilizou o Senai Play, Realidade Virtual, Maker e Theoprax com seus alunos para elaboração de protótipos.",
    },
    {
      id: 3,
      nome: "Celso Barreto da Silva ",
      unidade: "SENAI Cimatec",
      foto: pessoa3,
      thumb: video1,
      videoUrl: "https://www.youtube.com/embed/vk0TtCzekOE?si=o8LMs8zFv40L2ZbO",
      descricao:
      "Para ensinar Códigos Complexos, de forma cativante e prática, o professor Celso apostou na Aprendizagem Baseada em Desafios para desenvolver uma Solução Backend.",
    },
    {
      id: 4,
      nome: "Eliedson Gama Lima",
      unidade: "SENAI Sudoeste",
      foto: pessoa4,
      thumb: video1,
      videoUrl: "https://www.youtube.com/embed/Wx75OVOntCE?si=2ws4YsjyBVQdPTl8",
      descricao:
      "O professor Eliedson desenvolveu os conceitos sobre o que são Equipamentos Industriais, tipos, funções e modos de operação. Para tanto, ele realizou uma Ggamificação com seus alunos que foram convidados a produzir uma Storytelling sobre fios, compressores, bombas e afins.",
    },
    {
      id: 5,
      nome: "Filipe Almeida da Conceição Inocêncio",
      unidade: "SENAI Feira de Santana",
      foto: pessoa5,
      thumb: video1,
      videoUrl: "https://www.youtube.com/embed/HGDb12CPb-M?si=ouR2e5mgsjeKh5Z6",
      descricao:
      "O professor Filipe apostou na Gamificação através do Kahoot para fazer uma revisão geral da UC Projetos Elétricos Prediais Industriais, buscando preparar seus alunos para a prova do Centro de Instrução de Aviação Civil (CIAC).",
    },
    {
      id: 6,
      nome: "Hailla Chagas",
      unidade: "SENAI Sudoeste",
      foto: pessoa6,
      thumb: video1,
      videoUrl: "https://www.youtube.com/embed/Y2KYIKlf27Q?si=u0863Z1O6Iabscgg",
      descricao:
      "A partir de formatos midiáticos distintos como: jogos virtuais, Tik Toc, podcast, criação de letras de música, vídeos, os alunos da professora Hailla produziram conteúdos sobre a Indústria 4.0. Eles utilizaram Programas Digitais e Softwares de Inteligência Artificial como Capcut, Canvas, Chat GPT, Sound (Saund) para desenvolver protagonismo, autonomia, pensamento crítico, criatividade e domínio sobre os conceitos da disciplina.",
    },
    {
      id: 7,
      nome: "Leonardo Lins",
      unidade: "SENAI Alagoinhas",
      foto: pessoa7,
      thumb: video1,
      videoUrl: "https://www.youtube.com/embed/q3_js3pGTJQ?si=4Ge29bifyWH_wsGx",
      descricao:
      "O professor Leonardo, utilizou a tecnologia Senai Play e a Metodologia Situação de Aprendizagem para ensinar seus alunos a Organizar e Controlar Documentos.",
    },
    {
      id: 8,
      nome: "Manuela Fiais Salomão Santana",
      unidade: "SENAI Lauro de Freitas",
      foto: pessoa8,
      thumb: video1,
      videoUrl: "https://www.youtube.com/embed/fdzg8eIquyo?si=WEMTWLSjGRidKvBc",
      descricao:
      "A professora Manuela utilizou um curso de Senai Play para os alunos construírem um resumo do que foi aprendido na disciplina, desenvolvendo, dessa forma senso crítico, capacidade argumentativa e troca de experiências e percepções.",
    },
    {
      id: 9,
      nome: "Rafael Santiago Machado",
      unidade: "SENAI Cimatec",
      foto: pessoa9,
      thumb: video1,
      videoUrl: "https://www.youtube.com/embed/CQZG6rBj_7w?si=qwwoAcdZuA9JUEqT",
      descricao:
      "O professor Rafael liderou o estudo dos Processos da Fabricação Mecânica por meio da Realidade Virtual, estabelecendo uma relação dialógica entre o espaço físico do laboratório e o espaço digital imersivo.",
    },
    {
      id: 10,
      nome: "Romario Andrade Rodrigues",
      unidade: "SENAI Feira de Santana ",
      foto: pessoa10,
      thumb: video1,
      videoUrl: "https://www.youtube.com/embed/QQrcaLQq-gs?si=dT_KEcmeiZZtb4TT",
      descricao:
      "O professor Romário fez uma dobradinha com a Realidade Virtual e a Mesa Tática de Segurança do Trabalho para que os alunos avaliassem quais NRs são aplicadas a uma área de Carga e Descarga com utilização de empilhadeiras.",
    },
    {
      id: 11,
      nome: "Valmir Lima Acácio Júnior",
      unidade: "SENAI Camaçari",
      foto: pessoa11,
      thumb: video1,
      videoUrl: "https://www.youtube.com/embed/O9vsW9T8lj8?si=ckgGMDd8l2BdkM9m",
      descricao:
      "A aplicação Inovaê Docente do professor Valmir foi centrada no Kahoot para revisão dos assuntos abordados e o Google Forms para avaliar a turma de Eletromecânica de Manutenção.",
    },
   
  ];

  const itensPorPagina = 6;
  const totalPaginas = Math.ceil(pessoas.length / itensPorPagina);
  const [paginaAtual, setPaginaAtual] = useState(0);
  const [videoAberto, setVideoAberto] = useState(null);

  const paginas = Array.from({ length: totalPaginas }, (_, index) => {
    const inicio = index * itensPorPagina;
    return pessoas.slice(inicio, inicio + itensPorPagina);
  });

  const proximaPagina = () => {
    if (paginaAtual < totalPaginas - 1) {
      setPaginaAtual((prev) => prev + 1);
    }
  };

  const paginaAnterior = () => {
    if (paginaAtual > 0) {
      setPaginaAtual((prev) => prev - 1);
    }
  };

  return (
    <section className="tela04" style={{ backgroundImage: `url(${bgTl5})` }}>
      <div className="tela04__container">
        <div className="tela04__slider">
          <div
            className="tela04__track"
            style={{ transform: `translateX(-${paginaAtual * 100}%)` }}
          >
            {paginas.map((pagina, index) => (
              <div className="tela04__page" key={index}>
                <div className="tela04__grid">
                  {pagina.map((item) => (
                    <article className="tela04__card" key={item.id}>
                      <div className="tela04__header">
                        <img
                          src={item.foto}
                          alt={item.nome}
                          className="tela04__foto"
                        />

                        <div className="tela04__headerInfo">
                          <h3>{item.nome}</h3>
                          <span>{item.unidade}</span>
                        </div>
                      </div>

                      <p className="tela04__descricao">{item.descricao}</p>

                      <div className="tela04__videoBox">
                        <img
                          src={item.thumb}
                          alt={`Thumbnail de ${item.nome}`}
                          className="tela04__video"
                        />
                        <button
                          className="tela04__play"
                          aria-label={`Reproduzir vídeo de ${item.nome}`}
                          onClick={() => setVideoAberto(item)}
                        >
                          <FaPlay />
                        </button>
                      </div>

                    </article>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="tela04__footer">
          <button
            className="tela04__nav"
            onClick={paginaAnterior}
            disabled={paginaAtual === 0}
            aria-label="Página anterior"
          >
            <IoIosArrowBack />
          </button>

          <div className="tela04__dots">
            {Array.from({ length: totalPaginas }).map((_, index) => (
              <button
                key={index}
                className={`tela04__dot ${paginaAtual === index ? "ativo" : ""}`}
                onClick={() => setPaginaAtual(index)}
                aria-label={`Ir para página ${index + 1}`}
              />
            ))}
          </div>

          <button
            className="tela04__nav"
            onClick={proximaPagina}
            disabled={paginaAtual === totalPaginas - 1}
            aria-label="Próxima página"
          >
            <IoIosArrowForward />
          </button>
        </div>
      </div>

        {videoAberto && (
          <div className="video_modal" onClick={() => setVideoAberto(null)}>
            <div
              className="video_modal__content"
              onClick={(e) => e.stopPropagation()}
            >
              <button
                className="video_modal__close"
                onClick={() => setVideoAberto(null)}
                aria-label="Fechar vídeo"
              >
                ×
              </button>

              {videoAberto.videoUrl ? (
                <div className="video_modal__iframeWrapper">
                  <iframe
                    src={`${videoAberto.videoUrl}&autoplay=1`}
                    title={`Vídeo de ${videoAberto.nome}`}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerPolicy="strict-origin-when-cross-origin"
                    allowFullScreen
                  />
                </div>
              ) : (
                <video className="video_modal__player" controls autoPlay>
                  <source src={videoAberto.video} type="video/mp4" />
                  Seu navegador não suporta vídeo.
                </video>
              )}
            </div>
          </div>
        )}
      
    </section>
  );
}